
const actions = {
    setBasket(vuexContext, payload) {
        vuexContext.commit('setBasket', {
            items: payload.items
        });

        vuexContext.commit('setBasketState', true);
    },
    setBasketState(vuexContext, {state}) {
        vuexContext.commit('setBasketState', state);
    }
};

export default actions;